export default __webpack_public_path__ + "static/media/labicon.eb50fbf1.svg";